export const formatNumber = (value: number | string): string => {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(num)) {
        return "0";
    }

    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatCurrency = (value: number | string): string => {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(num)) {
        return "0.00";
    }

    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};